import { useMutation, useQueryClient } from '@tanstack/react-query'
import { attachDomain } from '../../services'
import { AdminMutationKey, AdminQueryKey } from '@/modules/admin/keys'
import { AttachDomainRequest, AttachDomainResponse } from '@/modules/admin/type'
import { toast } from 'sonner'

export default function useMutationAttachDomain() {
	const queryClient = useQueryClient()

	return useMutation<AttachDomainResponse, Error, AttachDomainRequest>({
		mutationKey: [AdminMutationKey.AttachDomain],
		mutationFn: (payload: AttachDomainRequest) => attachDomain(payload),
		onSuccess: (data) => {
			toast.success(data.message || 'เพิ่มโดเมนสำเร็จ')
			queryClient.invalidateQueries({ queryKey: [AdminQueryKey.GetDomains] })
		},
		onError: () => {
			toast.error('เพิ่มโดเมนล้มเหลว กรุณาลองใหม่อีกครั้ง')
		},
	})
}
